import * as Yup from "yup";

const maoObraValidator = Yup.object().shape({
  descricao: Yup.string().required("Descrição"),
  custoMensal: Yup.number()
    .required("Custo Mensal")
    .min(0.01, "Custo Mensal deve ser maior ou igual a 0.01"),
  encargos: Yup.number()
    .required("Encargos")
    .min(0.01, "Encargos deve ser maior ou igual a 0.01"),
  horasProdutivas: Yup.number()
    .required("Horas Produtivas")
    .min(1, "Horas Produtivas deve ser maior ou igual a 1"),
  custoHora: Yup.number()
    .required("Custo/Hora")
    .min(0.01, "Custo/Hora deve ser maior ou igual a 0.01"),
});

const maoObraListValidator = Yup.array().of(maoObraValidator);

export { maoObraValidator, maoObraListValidator };
